<script>
import { ref } from '@vue/composition-api'

export default {
  setup () {
    const loaded = ref(false)

    return {
      loaded,
    }
  },
}
</script>

<template>
  <div>
    <div
      v-show="loaded"
      class="demo relative p-6"
      :class="{
        loaded,
      }"
    >
      <div
        style="width: 300px;"
        class="mt-10 bg-black"
      >
        <video
          autoplay
          loop
          muted
          preload="metadata"
          style="width: 300px;  height: 590px;"
          class="max-w-auto pointer-events-none"
        >
          <source
            src="/demo.mp4"
            type="video/mp4"
          >
          Your browser does not support the HTML5 video tag.
        </video>
      </div>

      <img
        src="~@/assets/phone.png"
        alt="Phone image"
        class="absolute inset-0"
        @load="loaded = true"
      >
    </div>
    <div
      v-show="!loaded"
      style="width: 300px;"
    />
  </div>
</template>

<style lang="postcss" scoped>
.demo.loaded {
  animation: fade-in 1s ease-out backwards;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
